import { Slot, Slottable } from '@radix-ui/react-slot';
import styles from './back-link.module.css';
import { ClassName, cn } from '@lhb/ui';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { To, useNavigate } from 'react-router-dom';

type BackButtonProp = {
  label: React.ReactNode;
  className?: ClassName;
  requestId?: string;
  to?: To;
  asChild?: boolean;
  children?: React.ReactNode;
};

export function BackLink({
  label,
  className,
  to,
  asChild,
  children,
}: BackButtonProp) {
  'use client';
  const { t } = useTranslation();
  label = label || t('COMMON:GO_BACK');
  const navigate = useNavigate();
  const goBack = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      if (to) {
        navigate(to);
        return;
      }

      if (!window) return;
      window.history.back();
    },
    [to, navigate],
  );
  const Comp: React.ElementType = asChild ? Slot : 'button';
  return (
    <Comp
      onClick={goBack}
      className={cn(!asChild && styles['link'], className)}
    >
      {label}
      <Slottable>{children}</Slottable>
    </Comp>
  );
}
